import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarDoors,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import StockFilterRange from '@/components/StockFilterRange';

function DoorsFilter() {
  const dispatch = useTypedDispatch();
  const selectedDoors =
    useTypedSelector(getSelectedFilters).selectedParams.selectedDoors;

  const handleBlurDoors = (doors: RangeType) => {
    dispatch(setCarDoors(doors));
    dispatch(setPage(1));
  };

  return (
    <StockFilterRange
      label="Количество дверей"
      values={selectedDoors}
      onBlur={handleBlurDoors}
    />
  );
}

export default DoorsFilter;
